<template>
  <o-view :has-white-background="true" :no-scroll="true">
    <o-nav-bar title="Je Cambio-wagen openen" :has-back-button="true" />
    <o-section>
      <ol>
        <li>
          <p>
            <strong>
              Geef je persoonlijke pincode in op de boordcomputer in de wagen.
            </strong>
            Elke Cambio-gebruiker heeft zijn eigen code die geldig is voor elke
            reservatie.
          </p>
          <o-alert><p>Jouw pincode: 4321</p></o-alert>
        </li>
        <li>
          <p><strong>Beantwoord de schadevraag.</strong></p>
        </li>
        <li>
          <p><strong>Neem de sleutel uit de boordcomputer.</strong></p>
        </li>
        <li>
          <p><strong>Geniet van je rit.</strong></p>
        </li>
      </ol>
    </o-section>
  </o-view>
</template>

<script>
export default {
  name: 'CambioEdit'
}
</script>
